import { render, staticRenderFns } from "./payDeposit.vue?vue&type=template&id=1047ceb8&scoped=true"
import script from "./payDeposit.vue?vue&type=script&lang=js"
export * from "./payDeposit.vue?vue&type=script&lang=js"
import style0 from "./payDeposit.vue?vue&type=style&index=0&id=1047ceb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1047ceb8",
  null
  
)

export default component.exports